import { EgretLoadable } from 'egret'
import { FIRST_LOGIN_FLOW_PATHS } from './FirstLoginFlowConstants'

export const firstLoginFlowRoutes = [
  {
    path: FIRST_LOGIN_FLOW_PATHS.FIRST_LOGIN_FLOW,
    component: EgretLoadable({
      loader: async () => {
        return await import('./index')
      }
    })
  },
  {
    path: FIRST_LOGIN_FLOW_PATHS.CONNECT_TO_ORGANIZATION,
    component: EgretLoadable({
      loader: async () => {
        return await import('./ConnectToOrganizationRedirects')
      }
    })
  },
  {
    path: FIRST_LOGIN_FLOW_PATHS.CONNECT_TO_ORGANIZATION_SEARCH,
    component: EgretLoadable({
      loader: async () => {
        return await import('./OrganizationConnectSearchRedirects')
      }
    })
  },
  {
    path: FIRST_LOGIN_FLOW_PATHS.CONNECT_TO_ORGANIZATION_RESULTS,
    component: EgretLoadable({
      loader: async () => {
        return await import('./OrganizationConnectResultsRedirects')
      }
    })
  },
  {
    path: FIRST_LOGIN_FLOW_PATHS.CONNECT_TO_ORGANIZATION_TOO_MANY_RESULTS,
    component: EgretLoadable({
      loader: async () => {
        return await import('./OrganizationConnectTooManyResultsRedirects')
      }
    })
  },
  {
    path: FIRST_LOGIN_FLOW_PATHS.CONNECT_TO_ORGANIZATION_NO_RESULTS,
    component: EgretLoadable({
      loader: async () => {
        return await import('./OrganizationConnectNoResultsRedirects')
      }
    })
  },
  {
    path: FIRST_LOGIN_FLOW_PATHS.CONNECT_TO_ORGANIZATION_REQUEST_SENT,
    component: EgretLoadable({
      loader: async () => {
        return await import('./OrganizationConnectRequestSentRedirects')
      }
    })
  },
  {
    path: FIRST_LOGIN_FLOW_PATHS.CREATE_NEW_ORGANIZATION,
    component: EgretLoadable({
      loader: async () => {
        return await import('./CreateNewOrganizationRedirects')
      }
    })
  },
  {
    path: FIRST_LOGIN_FLOW_PATHS.ORGANIZATION_CREATED,
    component: EgretLoadable({
      loader: async () => {
        return await import('./OrganizationCreatedRedirects')
      }
    })
  }
]
